import { environment } from '../../../environments/environment';

/**
* State model declaration for store vehicle details
**/
export interface SelectedVehicleState {
  vehicle: object;
}
/**
* Initial State model for store vehicle details
**/
export const initialSelectedVehicleState: SelectedVehicleState = {
  vehicle: {}
};
